export default "__VITE_ASSET__580b30b7__"